import keyMirror from "keymirror";

// Developer Routes
export const DeveloperRoutes = {
  developer_route: "developer",
  // ================================
  // WORKFLOWS
  info_route: "info",
  workflow_route: "workflow",
  create_user_route: "create-user",
  organization_route: "organization",

  // UI GUIDES
  ui_guide_route: "ui-guide",
  breadcrumbs_route: "breadcrumbs",
  buttons_route: "buttons",
  cards_route: "cards",
  date_picker_route: "date-picker",
  drag_and_drop_route: "drag-and-drop",
  forms_route: "forms",
  icons_route: "icons",
  messaging_route: "messaging",
  modals_route: "modals",
  pagination_route: "pagination",
  popovers_route: "popovers",
  progress_bar_route: "progress-bar",
  public_cards_route: "public-cards",
  scrollbar_route: "scrollbar",
  tabs_route: "tabs",
  toastr_route: "toastr",
  toolbar_route: "toolbar",
  typography_route: "typography",

  // SANDBOX
  sandbox_route: "sandbox",
  
  // DIAGNOSTICS
  diagnostics: "diagnostics",
};

// Developer Navigation Paths
export const DeveloperNavigationPath = keyMirror({
  WorkflowNavigation: null,
  UiGuideNavigation: null,
  DefaultNavigation: null // catch all for independent / public components
});

export type DeveloperNavigationPathTypes = keyof typeof DeveloperNavigationPath;
